var PREFIX = "@GBC";
export var USER_TOKENS = PREFIX + ":USER_TOKENS";
export var AUTH_USER_DATA = PREFIX + ":AUTH_USER_DATA";
export var IP_CLIENT_DATA = PREFIX + ":IP_CLIENT_DATA";
